<template>
  <div class="app-content ap monitors">
    <b-row class="row mb-4">
      <b-col>
        <div class="d-flex h-100 w-100 align-items-center">
          <h1 class="ap__main-title">{{ category }} Insight Monitors</h1>
        </div>
      </b-col>
    </b-row>
    
    <b-row v-if="category == 'consumer'">
      <b-col cols="6" md="4" lg="3" xl="3" v-for="consumer in monitorConsumerGenerations" :key="consumer.id">
        <div class="card monitors__item mb-3">
          <router-link :to="{ name: 'MonitorsDashboardSubCategory', params: { category: 'consumer', tagId: consumer.id }}">
            <img :src="consumer.picture" class="card-img-top" :alt="consumer.generation">
          </router-link>
          <div class="card-body">
            <div class="card-text">
              <router-link :to="{ name: 'MonitorsDashboardSubCategory', params: { category: 'consumer', tagId: consumer.id }}" class="monitor__title">{{ consumer.generation }}</router-link>
              <p class="monitor__last-updated" v-if="consumer.updated_at"><small>Last update {{ consumer.updated_at | moment('YYYY-MM-DD') }}</small></p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    
    <b-row v-else>
      <b-col cols="6" md="4" lg="3" xl="3" v-for="market in monitorMarketSectors" :key="market.id">
        <div class="card monitors__item mb-3">
          <router-link :to="{ name: 'MonitorsDashboardSubCategory', params: { category: 'market', tagId: market.id }}">
            <img :src="market.picture" class="card-img-top" :alt="market.market">
          </router-link>
          <div class="card-body">
            <div class="card-text">
              <router-link :to="{ name: 'MonitorsDashboardSubCategory', params: { category: 'market', tagId: market.id }}" class="monitor__title">{{ market.sector }}</router-link>
              <p class="monitor__last-updated" v-if="market.updated_at"><small>Last update {{ market.updated_at | moment('YYYY-MM-DD') }}</small></p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import {
  GLOBAL_CHANGE_SECTION,
  MONITOR_GET_CONSUMER_GENERATIONS,
  MONITOR_GET_MARKET_SECTORS
} from "@/store/actions.type";

import {
  STATE_MONITORS_CURRENT_CATEGORY_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorsDashboardCategory',
  mixins: [monitorsDataMixin],
  data() {
    return {
      category: null
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "section"])
  },
  methods: {
    updateCategories() {
      this.$store.dispatch(MONITOR_GET_CONSUMER_GENERATIONS);
      this.$store.dispatch(MONITOR_GET_MARKET_SECTORS);
    }
  },
  mounted() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
      return;
    }

    if(this.section != 'monitors') {
      this.$store.dispatch(GLOBAL_CHANGE_SECTION, 'monitors');
      this.getMonitorsData();
    } else {
      this.updateCategories();
    }

    this.category = this.$route.params.category;
    this.$store.commit(STATE_MONITORS_CURRENT_CATEGORY_SET, this.category);

  }
}
</script>

<style lang="scss">
.app {

  &__loading {
    left: 0;
    top: 0;
    z-index: 999;
  }
}

.monitors {

  &__trash-button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(38px);
      height: rem(38px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }

  &__item {

    .card-body {
      padding: rem(12px) rem(16px);
    }
  }
}

.monitor {

  &__title {
    color: $color-genoa;
    transition: color .3s ease;
    font-weight: 700;
    font-size: rem(18px);

    &:hover {
      color: $color-java;
      text-decoration: none;
    }
  }

  &__last-updated {
    color: $color-abbey;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }
}
</style>